import '../../assets/scss/main.scss';
import '../../partials/Layout/scripts';
import '../../partials/Gallery/scripts';
import '../../partials/ContactFormDark/scripts';
import './partials/ActuationCard/scripts';
import './partials/ActuationModal/scripts';
import '../../partials/Dobra/scripts';
import './styles.scss';

document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search,);
  const actuation = urlParams.get('service',);

  if (actuation) {
    const actuationCard = document.querySelector(`[data-service="${actuation}"]`,);

    if (actuationCard) {
      setTimeout(() => {
        actuationCard.click();

        // remove the query string from the URL
        actuationCard.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center', },);
      }, 500,);  
    }
  }

  const actuationModal = document.querySelector('#modal-service',);

  // on card click add to query string
  const actuationCards = document.querySelectorAll('.actuation__item',);
  actuationCards.forEach((card,) => {
    card.addEventListener('click', () => {
      const service = card.dataset.service;
      
      const url = new URL(window.location,);
      url.searchParams.set('service', service,);
      window.history.pushState({ path: url.href, }, '', url.href,);

      // update modal content with card data
      const dataSetObject = card.dataset.object || '{}';

      const { name, description, } = JSON.parse(dataSetObject,);
      if (!name || !description) { return console.error('Missing data', { name, description, },); }
      actuationModal.querySelector('.modal__title',).textContent = name;
      actuationModal.querySelector('.modal__description',).innerHTML = description;
    },);
  },);
},);
